$(document).ready(function() {
$(".product-color-swatches .swatch-item").each(function() {
    var ColorName = $(this).attr("data-value");
    var bgColor = $(this).css("background-color");

    $('.product-detail .selector-wrapper.option--color ul.clickyboxes li a').each(function() {
        var swatches = $(this).attr("data-value");

        if (ColorName === swatches) {
            $(this).css("--swatch-color", bgColor);
        }
    });
});
  //       if (window.matchMedia("(max-width: 767px)").matches) {
  // $(".section-footer__row__col .set").on("click", function() {
  //   if ($(this).hasClass("active")) {
  //     $(this).removeClass("active");
  //     $(this).siblings(".content-acc").slideUp(200);
  //     $(".section-footer__row__col .set i").removeClass("faminus").addClass("faplus");
  //   } else {
  //     $(".section-footer__row__col .set i").removeClass("faminus").addClass("faplus");
  //     $(this).find("i").removeClass("faplus").addClass("faminus");
  //     $(".section-footer__row__col .set").removeClass("active");
  //     $(this).addClass("active");
  //     $(".content-acc").slideUp(200);
  //     $(this).siblings(".content-acc").slideDown(200);
  //   }
  // });
  // }
    function bindFooterAccordion() {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $(".section-footer__row__col .set").off("click").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".content-acc").slideUp(200);
        $(".section-footer__row__col .set i").removeClass("faminus").addClass("faplus");
      } else {
        $(".section-footer__row__col .set i").removeClass("faminus").addClass("faplus");
        $(this).find("i").removeClass("faplus").addClass("faminus");
        $(".section-footer__row__col .set").removeClass("active");
        $(this).addClass("active");
        $(".content-acc").slideUp(200);
        $(this).siblings(".content-acc").slideDown(200);
      }
    });
  } else {
    // Desktop mode me accordion disable
    $(".section-footer__row__col .set").off("click");
    $(".content-acc").show(); // Desktop pe content visible
  }
}

// Page load pe run karo
bindFooterAccordion();

// Resize hone par run karo
$(window).on("resize", function () {
  bindFooterAccordion();
});


});














document.addEventListener("DOMContentLoaded", function () {
  const fitGuide = document.querySelector(".mp-inline-button");
  const target = document.querySelector("#fit-guide-target");

  if (fitGuide && target) {
    target.appendChild(fitGuide);
  }
});
